import { AccordionDetails, Autocomplete, Box, Button, CircularProgress, FormControl, Grid, IconButton, MenuItem, Popper, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { selectFieldTextBlueBr } from '../../style/PharmacyStyle';
import { orangeButton, primaryBtnTeal, textfieldTextBlueBorder } from '../../style/PatientDetailsStyle';
import AddIcon from "@mui/icons-material/Add";
import { menuItemStyle, menuItemStyleContentWidth } from '../../style/AppointmentStyle';
import { showToast } from '../../utils/toastUtil';
import { xBtn } from '../../style/LapPageStyle';
import CloseIcon from "@mui/icons-material/Close";
import useFetchIpdCharges from '../../helper/useFetchIpdCharges';
import useDebounce from '../../hooks/UseDebounce';
import useFetchAdmissionList from '../../helper/useFetchAdmissionList';
import { postIPDCharges } from '../../connections/postApi';
import { useReactToPrint } from 'react-to-print';
import IpdChargesPrint from '../PrintCompoents/IpdChargesPrint';
import { getInvoiceDataById, orgDetails } from '../../connections/getApi';
import UseFetchGetOrganizationDetails from '../../helper/UseFetchGetOrganizationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { setData, setPatientId, setPatientInvoice, setRenderInvoice } from '../../redux/slices/billingSlice';
import UsePatientDetail from '../../helper/UsePatientDetail';

const IpdInvoices = ({ departmentID }) => {
  const {
    billing: { data: patientData, inVoiceData, medicalTest },
  } = useSelector((state) => state);
  const [ipdItems, setIpdItems] = useState([]);
  const { data: orgDetails } = UseFetchGetOrganizationDetails();
  const [searchAdmission, setSearchAdmission] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedAdmission, setSelectedAdmission] = useState(null);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentMode, setPaymentMode] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const [payload, setPayload] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);



  const { data: chargesList } = useFetchIpdCharges();
  const debounceSearchValue = useDebounce(searchAdmission, 300)
  const { data: admissionList, isLoading: admissionLoading } = useFetchAdmissionList(debounceSearchValue);
  const { data: patientDetailsQuery, isLoading: patientDetailLoading } = UsePatientDetail(selectedPatientId);

  const dispatch = useDispatch();
  // console.log(ipdItems, 'ipdItems')
  // ✅ Select Test/Charge from dropdown
  const handleSelectTest = (index, value) => {
    console.log(value, 'value');
    if (!value) return;

    setIpdItems((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        invoice_itemable_id: value.id,
        invoice_itemable_type: "Ipd::AdmissionCharge",
        name: value.name,
        price: value.price || 0,
        quantity: 1,
        discount: 0,
        total_amount: value.price || 0,
        total_discount: 0,
      };
      return updated;
    });
  };

  useEffect(() => {
    const discount = ipdItems.reduce(
      (acc, test) => acc + (test.discount ?? 0),
      0
    );

    const bill = ipdItems.reduce(
      (acc, test) => acc + (test.price ?? 0),
      0
    );

    setTotalDiscount(Math.ceil(+discount || 0));
    setTotalAmount(Math.ceil(+bill || 0 - +discount || 0));
  }, [ipdItems]);


  // ✅ Remove Item (mark destroy if existing, else just remove)
  const handleRemove = (index, itemId) => {
    setIpdItems((prev) => {
      const updated = [...prev];
      if (itemId) {
        // Existing item -> mark as removed
        updated[index] = { ...updated[index], _destroy: 1 };
      } else {
        // New item -> remove completely
        updated.splice(index, 1);
      }
      return updated;
    });
  };


  // ✅ Add new blank row
  const handleAddTest = () => {
    setIpdItems((prev) => [
      ...prev,
      {
        // id: null,
        invoice_itemable_id: null,
        invoice_itemable_type: "Ipd::AdmissionCharge",
        name: "",
        quantity: 1,
        price: 0,
        discount: 0,
        total_amount: 0,
        total_discount: 0,
      },
    ]);
  };

  // console.log(ipdItems, 'ipdItems');
  // console.log(inVoiceData, 'inVoiceData');
  const [advancedPayment, setAdvancedPayment] = useState(0);

  const handleClickInvoiceIPD = async (inVoiceId, patientId) => {
    setLoadingInvoice(true);
    try {
      if (inVoiceId) {
        const data = await getInvoiceDataById(inVoiceId);
        dispatch(setPatientInvoice(data?.payload));
      }
      if (patientId) {
        // const PatientData = await getPatient(patientId);
        // dispatch(setData(PatientData?.payload));
        // console.log(PatientData);
        // console.log(patientId, 'patientId');
        dispatch(setPatientId(patientId));
        setSelectedPatientId(patientId)
      }
      // setIndexRow(inVoiceId);
      setLoadingInvoice(false);
    } catch (error) {
      showToast("Something Went Wrong", "ERROR");
      setLoadingInvoice(false);
    }
  };

  // useEffect(() => {
  //   if (inVoiceData?.department_name === "IPD") {
  //     const mappedItems = inVoiceData?.invoice_items?.map((item) => ({
  //       id: item?.id,
  //       invoice_itemable_id: item?.invoice_itemable_id,
  //       invoice_itemable_type: item?.invoice_itemable_type,
  //       name: item.name || "",
  //       quantity: item.quantity || 1,
  //       cost_per: item?.cost_per_unit || 0,
  //       price: item?.cost || 0,
  //       discount: item.discount || 0,
  //       discount_per: item.discount_per_unit || 0,
  //       total_amount: item.amount || 0,
  //       total_discount: item.discount || 0,
  //       refund: item.refund || false,
  //     }));

  //     setIpdItems(mappedItems);
  //     setSelectedAdmission({
  //       id: inVoiceData?.ipd_admission?.id,
  //       uid: inVoiceData?.ipd_admission?.uid,
  //       patient: { id: inVoiceData?.ipd_admission?.patient_id }
  //     });
  //     setRemarks(inVoiceData?.remarks);
  //     setPaymentMode(inVoiceData?.payment_mode)
  //   }
  // }, [inVoiceData]);

  // console.log(patientData?.payload?.id, 'patient data ')

  useEffect(() => {
    if (inVoiceData?.department_name === "IPD") {
      let advancedPaymentItem = null;
      const mappedItems = inVoiceData?.invoice_items
        ?.filter((item) => {
          // Keep all except Advance Payment
          if (item?.name === "Advance Payment") {
            advancedPaymentItem = item?.amount;
            return false;
          }
          return true;
        })
        ?.map((item) => ({
          id: item?.id,
          invoice_itemable_id: item?.invoice_itemable_id,
          invoice_itemable_type: item?.invoice_itemable_type,
          name: item.name || "",
          quantity: item?.quantity || 1,
          cost_per: item?.cost_per_unit || 0,
          price: (+item?.amount || 0) + (item?.discount || 0),
          discount: item.discount || 0,
          discount_per: item.discount_per_unit || 0,
          total_amount: item.amount || 0,
          total_discount: item.discount || 0,
          refund: item.refund || false,
        }));

      if (advancedPaymentItem) {
        setAdvancedPayment(advancedPaymentItem);
      }
      setIpdItems(mappedItems);
      setSelectedAdmission({
        id: inVoiceData?.ipd_admission?.id,
        uid: inVoiceData?.ipd_admission?.uid,
        patient: { id: inVoiceData?.ipd_admission?.patient_id },
      });
      setRemarks(inVoiceData?.remarks);
      setPaymentMode(inVoiceData?.payment_mode);
    } else {
      setIpdItems([]);
      setTotalAmount(0);
      setTotalDiscount(0);
      setSelectedAdmission(null);
      setPaymentMode(null);
      setRemarks('');
      setAdvancedPayment(0)
    }
  }, [inVoiceData]);

  useEffect(() => {
    if (patientDetailsQuery) {
      dispatch(setData({
        payload: {
          ...patientDetailsQuery?.payload,
        },
      }));
    }
  }, [patientDetailsQuery, dispatch]);


  // console.log(selectedAdmission, 'selectedAdmission')
  // ✅ Build payload for submit
  const handleSubmit = async () => {
    if (!selectedAdmission) {
      showToast('Please select Admission Mo', 'ERROR');
      return null;
    }

    if (!paymentMode) {
      showToast('Please select Payment mode first', 'ERROR');
      return null;
    }

    const validItems = ipdItems.filter(
      (item) => item.invoice_itemable_id || item?.name
    );

    if (validItems?.length === 0) {
      // console.log('sending pay ', validItems, ipdItems)
      showToast('Please select any charges to proceed', 'ERROR');
      return null;
    }

    setIsLoading(true);

    const existingAdvanceItem = inVoiceData?.invoice_items?.find(
      (i) => i?.name === "Advance Payment"
    );

    // ✅ Find deleted items
    const existingIds = inVoiceData?.invoice_items?.map((i) => i.id) || [];
    const currentIds = ipdItems?.map((i) => i.id).filter(Boolean);

    const deletedItems = existingIds
      // ✅ Only include deleted IDs
      .filter((id) => !currentIds.includes(id))
      // ✅ If Advance Payment item exists, only mark _destroy when advancedPayment is falsy (0 or empty)
      .filter((id) => {
        const isAdvanceItem = id === existingAdvanceItem?.id;
        if (isAdvanceItem) {
          // only destroy if advancedPayment is empty/0
          return !Number(advancedPayment);
        }
        return true; // normal deleted items go through
      })
      .map((id) => ({ id, _destroy: 1 }));

    const total = totalAmount;
    const discount = totalDiscount;
    const grand_total = totalAmount - totalDiscount;

    const hasAdvancePayment = (chargesList?.payload?.admission_charges || []).some(
      (item) => item.name === "Advance Payment"
    );

    const advancePaymentCharge = (chargesList?.payload?.admission_charges || []).find(
      (item) => item?.name === "Advance Payment"
    );

    const advancePaymentItem = hasAdvancePayment && advancedPayment
      ? {
        ...(existingAdvanceItem?.id ? { id: existingAdvanceItem.id } : {}),
        invoice_itemable_id: advancePaymentCharge?.id,
        invoice_itemable_type: "Ipd::AdmissionCharge",
        name: "Advance Payment",
        quantity: 1,
        price: Number(advancedPayment),
        discount: 0,
        total_amount: Number(advancedPayment),
        total_discount: 0,
      }
      : null;

    // Calculate adjusted totals
    const adjustedTotal = Number(total) - Number(advancedPayment || 0);
    const adjustedGrandTotal = Number(grand_total) - Number(advancedPayment || 0);


    const payload = {
      billing: {
        ...(inVoiceData?.id ? { id: inVoiceData?.id } : {}),
        patient_id: selectedAdmission?.patient?.id || patientData?.payload?.id,
        invoiceable_type: "Ipd::Admission",
        invoiceable_id: selectedAdmission?.id,
        payment_mode: paymentMode,
        remarks,
        items: [
          ...validItems?.map((item) => ({
            id: item?.id,
            invoice_itemable_id: item?.invoice_itemable_id,
            invoice_itemable_type: "Ipd::AdmissionCharge",
            name: item?.name,
            quantity: item?.quantity,
            price: item?.price / item?.quantity,
            discount: item?.discount / item?.quantity,
            total_amount: item?.price - item?.discount,
            total_discount: item?.discount,
          })),
          ...(advancePaymentItem ? [advancePaymentItem] : []),
          ...deletedItems, // ✅ Add removed items here
        ],
        total: adjustedTotal,
        discount,
        grand_total: adjustedGrandTotal,
        department_id: departmentID || 11,
      },
    };

    // console.log("Final Payload =>", payload);
    try {
      const result = await postIPDCharges(payload);

      if (result?.status?.status === 'SUCCESS') {
        setPayload({ ...result?.payload, organization: orgDetails?.payload })
        // console.log(result, 'result');
        setTimeout(() => {
          handlePrint();
          setIpdItems([]);
          setTotalAmount(0);
          setTotalDiscount(0);
          setSelectedAdmission(null);
          setPaymentMode(null);
          setRemarks('');
          setAdvancedPayment(0)
          dispatch(setPatientInvoice([]));
          dispatch(setRenderInvoice());
        }, 300)

        showToast(result?.status?.message || "Generating Invoice", result?.status?.status);
      }
      else {
        showToast(result?.status?.message, result?.status?.status);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false);
    }
    // 🔽 send to API
    // await axios.post("/ipd/invoices", payload);
  };

  const testCharges = useRef();

  const handlePrint = useReactToPrint({
    content: () => testCharges.current,
    documentTitle: "Invoice Print",
    onAfterPrint: () => console.log("Print job finished"),
  });

  // console.log(advancedPayment, 'advancedPayment');

  return (
    <AccordionDetails sx={{ backgroundColor: "neutral.white", padding: "20px 20px" }}>

      <Grid container spacing={0} mb={2} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid item sm={3} lg={3} >
          <Typography variant="title1_medium">Admission No.</Typography>
        </Grid>
        <Grid item sm={8} lg={8}>
          <Box sx={{ width: '100%' }}>
            <Autocomplete
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              clearIcon={false}
              sx={{
                ...textfieldTextBlueBorder,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  height: "40px",
                  padding: "9px !important",
                  "& input": {
                    padding: "8px",
                    fontSize: "14px",
                  },
                },
              }}

              fullWidth
              options={admissionList?.payload?.admissions || []}
              getOptionLabel={(option) => option?.uid || ""}
              value={selectedAdmission}
              inputValue={searchAdmission}
              onInputChange={(event, newInputValue, reason) => {
                console.log('newInputValue', newInputValue)
                setSearchAdmission(newInputValue);
              }}
              onChange={(event, newValue) => {
                handleClickInvoiceIPD(newValue?.invoice_id, newValue?.patient?.id); setSelectedAdmission(newValue);

                //reset this is only new invoices
                setIpdItems([]);
                setTotalAmount(0);
                setTotalDiscount(0);
                setPaymentMode(null);
                setRemarks('');
                setAdvancedPayment(0)

              }}
              PopperComponent={(props) => (
                <Grid item lg={8}>
                  <Popper {...props} placement="bottom-start" style={menuItemStyleContentWidth} />
                </Grid>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Admission no"
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {admissionLoading ? (
                          <CircularProgress color="primary" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              renderOption={(props, option) => (
                <MenuItem sx={menuItemStyle} {...props} key={option?.id}>
                  {option?.uid || ""}
                </MenuItem>
              )}
            />

          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={0} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid item sm={3} lg={3}>
          <Typography variant="title1_medium">Mode of Payment</Typography>
        </Grid>
        <Grid item sm={8} lg={8}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
            <Box sx={{ width: '60%' }}>
              <FormControl fullWidth variant="outlined">
                <Select
                  required
                  fullWidth
                  sx={{
                    ...selectFieldTextBlueBr,
                    minWidth: '120px',
                    width: '100%',
                    "&:hover": {
                      borderRadius: '10px',
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  name="payment_type"
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "#A0A0A0" }}>
                          Payment Mode
                        </span>
                      );
                    }
                    return selected; // ✅ Show selected value
                  }}
                >
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Card">Card</MenuItem>
                  <MenuItem value="Cheque">Cheque</MenuItem>
                  <MenuItem value="UPI">UPI</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ width: '40%' }}>
              <TextField
                value={remarks}
                placeholder="Remarks"
                onChange={(e) => setRemarks(e.target.value)}
                sx={{
                  ...textfieldTextBlueBorder,
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid
        mt={2}
        container
        spacing={2}
        sx={{
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <Grid item sm={4} lg={4}
          sx={{
            paddingLeft: 0,
          }} >
          <Typography variant="title1_medium">Description</Typography>
        </Grid>
        <Grid alignItems={"start"} item sm={7} lg={7}>
          <Box
            display={"flex"}
            gap={"1px"}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            width="100%"
          >
            <Typography p={0} variant="title1_medium">
              No of days
            </Typography>
            <Typography
              variant="title1_medium"
              sx={{ marginRight: "20px" }}
            >
              Cost
            </Typography>
            <Typography
              variant="title1_medium"
              sx={{ marginRight: "20px" }}
            >
              Discount
            </Typography>
          </Box>
        </Grid>
        <Grid alignItems={"end"} sm={1} item lg={1}
          sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }}
        >
          <IconButton
            variant="contained"
            sx={{ ...orangeButton, marginLeft: "8px" }}
            onClick={() => handleAddTest()}
          >
            <AddIcon
              sx={{
                width: "25px",
                color: "neutral.white",
                margin: "0px",
                height: "25px",
                padding: "0px",
              }}
            />
          </IconButton>
        </Grid>

        {ipdItems?.map((test, index) => (
          <Grid
            key={index}
            item
            lg={12}
            gap={1}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <Grid item sm={4} lg={4}>
              <Autocomplete
                clearIcon={false}
                sx={{
                  ...textfieldTextBlueBorder,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    height: "40px",
                    padding: "9px !important",
                    "& input": {
                      padding: "8px",
                      fontSize: "14px",
                    },
                  },
                }}
                fullWidth
                options={
                  (chargesList?.payload?.admission_charges || []).filter(
                    (item) => item.name !== "Advance Payment"
                  )
                }
                getOptionLabel={(option) => option.name} // Use the 'name' property for display
                value={
                  chargesList?.payload?.admission_charges?.find(
                    (testObj) => testObj?.name === test?.name
                  ) || null
                }
                onChange={
                  (event, newValue) =>
                    handleSelectTest(index, newValue)
                }
                PopperComponent={(props) => (
                  <Grid item lg={8}>
                    <Popper
                      {...props}
                      placement="bottom-start"
                      style={menuItemStyleContentWidth}
                    />
                  </Grid>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Test"
                    variant="outlined"
                    fullWidth
                  />
                )}
                renderOption={(props, option) => (
                  <MenuItem
                    sx={menuItemStyle}
                    {...props}
                    key={option.id}
                  >
                    {option.name}{" "}
                    {/* Display the 'name' of each test */}
                  </MenuItem>
                )}
              />
            </Grid>
            <Grid item sm={7} lg={7}
              sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }} >
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                gap={"8px"}
                alignItems={"center"}
                width="100%"
              >
                <TextField
                  type="number"
                  // defaultValue={1}
                  value={test?.quantity || ''}
                  placeholder="quantity"
                  fullWidth
                  onChange={(e) => {
                    const newQty = e.target.value;
                    if (+newQty > 0) {
                      setIpdItems((prev) => {
                        const updatedTests = [...prev];
                        updatedTests[index] = {
                          ...updatedTests[index],
                          quantity: +newQty,
                          price: Math.ceil(
                            +newQty * test?.cost_per
                          ),
                          discount: Math.ceil(
                            +newQty * test?.discount_per
                          ),
                        };
                        return updatedTests;
                      });
                    } else {
                      setIpdItems((prev) => {
                        const updatedTests = [...prev];
                        updatedTests[index] = {
                          ...updatedTests[index],
                          quantity: newQty, // Let raw value be temporarily a string
                        };
                        return updatedTests;
                      });
                    }
                  }}
                  onBlur={(e) => {
                    const newQty = +e.target.value;
                    setIpdItems((prev) => {
                      const updatedTests = [...prev];
                      updatedTests[index] = {
                        ...updatedTests[index],
                        quantity: newQty > 0 ? newQty : 1, // Enforce minimum of 1
                      };
                      return updatedTests;
                    });
                  }}
                  // inputProps={{
                  //   min: 1,
                  // }}
                  sx={{
                    ...textfieldTextBlueBorder,
                  }}
                // disabled
                />

                <TextField
                  type="number"
                  value={test?.price || ""}
                  placeholder="Cost"
                  fullWidth
                  onChange={(e) => {
                    const newAmount = e.target.value
                    setIpdItems((prev) => {
                      const updatedTests = [...prev];
                      updatedTests[index] = {
                        ...updatedTests[index],
                        price: +newAmount,
                        cost_per: +newAmount,
                        // cost: newQty,   // Temporarily set the raw input
                      };
                      return updatedTests;
                    });
                  }}
                  onBlur={(e) => {

                    let newAmount = parseFloat(e.target.value);
                    if (isNaN(newAmount) || newAmount <= 0) {
                      newAmount = 1; // Set minimum valid value
                    }
                    if (+newAmount < +test?.discount) {
                      newAmount = +test?.discount; // Auto-correct to discount
                      showToast("Cost cannot be less than discount. Adjusted automatically.", "ERROR");
                    }
                    setIpdItems((prev) => {
                      const updatedTests = [...prev];
                      updatedTests[index] = {
                        ...updatedTests[index],
                        price: test.quantity > 0 ? +newAmount : 0,
                        cost_per: test.quantity > 0 ? +newAmount : 0,
                        // cost: newQty > 0 ? newQty : 1,   // Validate on blur
                      };
                      return updatedTests;
                    });
                  }}
                  // inputProps={{
                  //   min: 1,
                  // }}
                  sx={{
                    ...textfieldTextBlueBorder,
                  }}
                />

                <TextField
                  type="number"
                  value={test?.discount || ""}
                  placeholder="Discount"
                  fullWidth
                  onChange={(e) => {
                    const disc = e.target.value.replace(
                      /[^0-9]/g,
                      ""
                    );
                    setIpdItems((prev) => {
                      const updatedTests = [...prev];
                      updatedTests[index] = {
                        ...updatedTests[index],
                        discount_per: Math.ceil(+disc),
                        discount: Math.ceil(+disc)
                      };
                      return updatedTests;
                    });
                  }}
                  onBlur={(e) => {
                    const disc = +e.target.value; // Convert to number on blur
                    if (disc > +test?.price) {
                      showToast("Discount cannot be greater than cost . Adjusted automatically.", "ERROR"); setIpdItems((prev) => {
                        const updatedTests = [...prev];
                        updatedTests[index] = {
                          ...updatedTests[index],
                          discount: test?.price,
                          discount_per: test?.price,
                        };
                        return updatedTests;
                      });
                    }
                  }}
                  inputProps={{
                    min: 0,
                  }}
                  sx={{
                    ...textfieldTextBlueBorder,
                  }}
                />
              </Box>
            </Grid>

            <Grid sm={1} item lg={1}>
              <IconButton
                sx={{
                  marginBottom: "7px",
                  display:
                    test?.report_status === "processing" ||
                      test?.report_status === "done"
                      ? "none"
                      : "",
                }}
                onClick={() =>
                  handleRemove(index, test?.itemId)
                }
              >
                <CloseIcon
                  sx={{
                    ...xBtn,
                    width: "23px",
                    height: "23px",
                  }}
                />
              </IconButton>
            </Grid>
          </Grid>
        ))}

        <Grid
          item
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={'end'}
          xs={12}
        >

          <Box mb={1}>
            <Typography variant="title1_medium">
              Net Discount: {" "}
            </Typography>
            <Typography variant="title1_medium">
              {totalDiscount}
            </Typography>
          </Box>

          <Box sx={{ flexDirection: 'column', gap: 4 }}>
            {(chargesList?.payload?.admission_charges || []).some(
              (item) => item.name === "Advance Payment"
            ) && (
                <Box
                  display={"flex"}
                  gap={1}
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                >
                  <Typography variant="title1_medium">
                    Advanced Payments
                  </Typography>
                  <TextField
                    type="number"
                    onChange={(e) => setAdvancedPayment(e.target.value)}
                    value={advancedPayment}
                    placeholder="Advanced Payments"
                    // InputProps={{ readOnly: true }}
                    onBlur={() => {
                      const total = Number(totalAmount);
                      if (Number(advancedPayment) > total) {
                        setAdvancedPayment(total);
                      }
                    }}
                    sx={{
                      ...textfieldTextBlueBorder,
                    }}
                  />
                </Box>)}

            <Box
              display={"flex"}
              gap={1}
              mt={2}
              alignItems={"center"}
              justifyContent={"flex-end"}
            >
              <Typography variant="title1_medium">
                Net Payable Amount
              </Typography>
              <TextField
                type="number"
                value={(totalAmount - (totalDiscount || 0)) - advancedPayment}
                placeholder="Net amount"
                InputProps={{ readOnly: true }}
                sx={{
                  ...textfieldTextBlueBorder,
                }}
              />
            </Box>
          </Box>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "12px",
          }}
        >
          <Box></Box>
          <Box>
            <Button
              disabled={isLoading}
              onClick={() => handleSubmit()}
              sx={{
                ...primaryBtnTeal,
                color: "white",
                borderRadius: "8px",
                py: "3px",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              }}
            >
              <Typography variant="small_Text">
                Save & Print
              </Typography>
            </Button>
          </Box>
        </Box>
      </Grid>
      <IpdChargesPrint props={payload} ref={testCharges} />
    </AccordionDetails>
  )
}

export default IpdInvoices;